import { AbstractControl } from '@angular/forms';

import { GetNextId } from '@eiq/shared/utils';

/** Persist the high-water mark on the owning list; removing/reordering options never lowers it. */
export function reserveOptionId(lastIndex: AbstractControl<number>, options: { id: string }[]): { id: string; value: string } {
  if (!Number.isSafeInteger(lastIndex.value) || lastIndex.value < 0) {
    throw new Error('Invalid last option index');
  }
  const nextIndex = Math.max(lastIndex.value ?? 0, Number(GetNextId(options, 'opt').value) - 1) + 1;
  if (!Number.isSafeInteger(nextIndex) || nextIndex < 1) {
    throw new Error('Invalid last option index');
  }
  lastIndex.setValue(nextIndex);
  return { id: `opt_${nextIndex}`, value: `${nextIndex}` };
}
